import React, { useState } from "react";
import { IoSearch, IoClose } from "react-icons/io5";
import "./InputSearch.scss";
import { useTranslation } from "react-i18next";


const InputSearch = ({
    placeholder = "",
    onSearch,
    className = "",
    variant = "default",
    disabled = false,
    error = false,
    onFocus = () => {},
}) => {
    const { t } = useTranslation();
    const [searchTerm, setSearchTerm] = useState("");

    const handleInputChange = (e) => {
        const value = e.target.value;
        setSearchTerm(value);

        if (onSearch) {
            onSearch(value);
        }
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (onSearch && !disabled) {
            onSearch(searchTerm);
        }
    };

    const handleClear = () => {
        if (!disabled) {
            setSearchTerm("");
            if (onSearch) {
                onSearch("");
            }
        }
    };

    const getClassNames = () => {
        let classes = ["search-bar"];

        if (variant !== "default") {
            classes.push(`search-bar--${variant}`);
        }

        if (disabled) {
            classes.push("search-bar--disabled");
        }

        if (error) {
            classes.push("search-bar--error");
        }

        if (className) {
            classes.push(className);
        }

        return classes.join(" ");
    };

    return (
        <form className={getClassNames()} onSubmit={handleSubmit}>
            <div className="search-bar__container">
                <IoSearch className="search-bar__icon" />

                <input
                    type="text"
                    className="search-bar__input"
                    placeholder={placeholder}
                    value={searchTerm}
                    onChange={handleInputChange}
                    onFocus={onFocus}
                    disabled={disabled}
                    autoComplete="off"
                />

                {searchTerm && !disabled && (
                    <button
                        type="button"
                        className="search-bar__clear"
                        onClick={handleClear}
                        aria-label={t("ui.inputs.clearSearch")}
                    >
                        <IoClose />
                    </button>
                )}
            </div>
        </form>
    );
};

export default InputSearch;
